module.exports = __webpack_public_path__ + "assets/images/c6116734998ae2ac49b7c2949bd51cff.png";